(function () {
  const SELECTOR = '[data-wall-mural-picker]';

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  };

  function initMuralPicker(container) {
    // Elements
    const materialGrid = container.querySelector('[data-material-grid]');
    const unitRadios = container.querySelectorAll('input[name="unit_selector"]'); // Select radio buttons
    const inputGroups = container.querySelectorAll('[data-input-group]');

    // Description Element
    const descriptionElement = container.querySelector('[data-material-description]');

    // Helper Note
    const validationNote = container.querySelector('[data-validation-note]');

    // Summary Elements
    const sumMaterial = container.querySelector('[data-summary-material]');
    const sumSize = container.querySelector('[data-summary-size]');
    const sumArea = container.querySelector('[data-summary-area]');
    const sumPrice = container.querySelector('[data-summary-price]');

    // Buttons
    const sampleButton = container.querySelector('[data-order-sample]');
    const addToCartButton = container.querySelector('[data-add-to-cart]');

    // Form Inputs
    const formMaterial = container.querySelector('[data-form-material]');
    const formWidth = container.querySelector('[data-form-width]');
    const formHeight = container.querySelector('[data-form-height]');
    const formUnit = container.querySelector('[data-form-unit]');
    const formArea = container.querySelector('[data-form-area]');
    const formPrice = container.querySelector('[data-form-price]');
    const formPriceUsd = container.querySelector('[data-form-price-usd]');
    const formMuralBasePriceUsd = container.querySelector('[data-form-mural-base-price-usd]');
    const formCalculatedPrice = container.querySelector('[data-form-calculated-price]');
    const formMaterialCode = container.querySelector('[data-form-material-code]');
    const formSizeCode = container.querySelector('[data-form-size-code]');

    const sectionId = container.getAttribute('data-section-id');
    const formId = container.getAttribute('data-product-form');
    const productForm = formId ? document.getElementById(formId) : null;
    const addButton = addToCartButton || (productForm ? productForm.querySelector('.product-form__submit') : null);

    // Main Price Elements
    const priceWrapper = sectionId ? document.getElementById(`price-${sectionId}`) : null;
    const priceTargets = priceWrapper ? Array.from(priceWrapper.querySelectorAll('.price-item--regular')) : [];
    const priceOriginals = priceTargets.map((node) => node.innerHTML);

    // Data
    let materials = [];
    let currentUnit = 'inch'; // Default to inch
    let selectedMaterial = null;
    let currentDims = { w: 0, h: 0, w_ft: 0, w_in: 0, h_ft: 0, h_in: 0 };

    // Formatting - get currency info from Shopify's global object or data attributes
    const moneyFormat = container.getAttribute('data-money-format') || '${{amount}}';
    // Try Shopify.currency.rate first, then fall back to data attribute
    const currencyRate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate)
      ? parseFloat(window.Shopify.currency.rate)
      : (parseFloat(container.getAttribute('data-currency-rate')) || 1);

    const formatMoney = (cents) => {
      const amount = (cents / 100).toFixed(2);
      const amountWithComma = amount.replace('.', ',');
      const amountNoDecimals = Math.round(cents / 100).toString();

      return moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_with_comma_separator}}', amountWithComma)
        .replace('{{amount_no_decimals}}', amountNoDecimals);
    };

    // Convert USD cents to display currency cents
    const toDisplayCurrency = (centsUSD) => {
      return Math.round(centsUSD * currencyRate);
    };

    // Price Display Helpers
    const resetPriceDisplay = () => {
      if (sumPrice) sumPrice.textContent = '—';
      if (formPrice) formPrice.value = '';
      if (formCalculatedPrice) formCalculatedPrice.value = '';
      if (formMaterialCode) formMaterialCode.value = '';
      if (formSizeCode) formSizeCode.value = '';
      priceTargets.forEach((node, index) => {
        node.innerHTML = priceOriginals[index];
      });
    };

    const applyPriceDisplay = (centsUSD) => {
      // centsUSD is the price in USD cents (base currency)
      // Convert to display currency for showing to user
      const centsDisplay = toDisplayCurrency(centsUSD);
      const formatted = formatMoney(centsDisplay);

      if (sumPrice) sumPrice.textContent = formatted;
      // Cart Transform expects price in presentment (display) currency
      if (formPrice) formPrice.value = centsDisplay;
      if (formPriceUsd) formPriceUsd.value = Math.round(centsUSD); // canonical USD
      if (formMuralBasePriceUsd) formMuralBasePriceUsd.value = Math.round(centsUSD);
      if (formCalculatedPrice) formCalculatedPrice.value = formatted;
      priceTargets.forEach((node) => {
        node.innerHTML = formatted;
      });
    };

    // Update sample button price display
    function updateSamplePrice() {
      if (!sampleButton) return;
      const priceSpan = sampleButton.querySelector('[data-sample-price]');
      if (!priceSpan) return;
      const samplePriceDisplay = toDisplayCurrency(600); // $6.00 USD
      priceSpan.textContent = formatMoney(samplePriceDisplay);
    }

    // 1. Load Data
    try {
      const jsonScript = container.querySelector('[data-pricing-json]');
      if (jsonScript) {
        const data = JSON.parse(jsonScript.textContent);
        materials = data.materials || [];
        renderMaterials();
        updateSamplePrice();

        // Clear default values (set for no-JS/Google bot compatibility)
        // Real users with JS will see empty inputs and "—" placeholders
        container.querySelectorAll('input[data-dim]').forEach(input => {
          input.value = '';
        });
        // Reset summary to placeholders
        if (sumMaterial) sumMaterial.textContent = '—';
        if (sumSize) sumSize.textContent = '—';
        if (sumArea) sumArea.textContent = '0 m²';
        if (sumPrice) sumPrice.textContent = '—';
        // Clear hidden form values
        if (formMaterial) formMaterial.value = '';
        if (formWidth) formWidth.value = '';
        if (formHeight) formHeight.value = '';
        if (formArea) formArea.value = '';
        if (formPrice) formPrice.value = '';
        if (formCalculatedPrice) formCalculatedPrice.value = '';
        if (formMaterialCode) formMaterialCode.value = '';
        if (formSizeCode) formSizeCode.value = '';
      }
    } catch (e) {
      console.error('Error parsing pricing JSON', e);
    }

    // 2. Render Materials
    function renderMaterials() {
      materialGrid.innerHTML = '';
      materials.forEach(mat => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mural-btn';
        btn.dataset.id = mat.id;
        btn.innerHTML = `
          <div class="mural-btn-label">${mat.label}</div>
          <div class="mural-btn-desc"></div> 
        `;
        btn.onclick = () => selectMaterial(mat);
        materialGrid.appendChild(btn);
      });

      updateMaterialPrices(currentUnit);
    }

    // Update unit prices on buttons
    function updateMaterialPrices(unit) {
      const buttons = materialGrid.querySelectorAll('.mural-btn');
      buttons.forEach(btn => {
        const matId = btn.dataset.id;
        const mat = materials.find(m => m.id === matId);
        if (!mat) return;

        const descSpan = btn.querySelector('.mural-btn-desc');
        if (!descSpan) return;

        let priceText = '';
        if (unit === 'cm') {
          // Convert USD cents to display currency
          const displayPrice = toDisplayCurrency(mat.price_per_sqm);
          priceText = `${formatMoney(displayPrice)} / m²`;
        } else {
          const pricePerSqFtCentsUSD = Math.round(mat.price_per_sqm / 10.7639);
          const displayPrice = toDisplayCurrency(pricePerSqFtCentsUSD);
          priceText = `${formatMoney(displayPrice)} / sq ft`;
        }
        descSpan.textContent = priceText;
      });
    }

    // 3. Logic
    function selectMaterial(mat) {
      selectedMaterial = mat;

      // Update UI
      container.querySelectorAll('.mural-btn').forEach(b => {
        b.classList.toggle('is-selected', b.dataset.id === mat.id);
      });

      // Update Summary & Form
      sumMaterial.textContent = mat.label;
      formMaterial.value = mat.label;
      if (formMaterialCode) formMaterialCode.value = mat.id;

      // Show Description
      if (descriptionElement) {
        if (mat.description) {
          descriptionElement.innerHTML = mat.description.replace(/^([^:]+:)/, '<b>$1</b>');
          descriptionElement.style.display = 'block';
        } else {
          descriptionElement.style.display = 'none';
        }
      }

      // Enable Sample Button
      if (sampleButton) sampleButton.disabled = false;

      calculate();
    }

    function switchUnit(unit) {
      const previousUnit = currentUnit;
      currentUnit = unit;

      // Convert existing dimensions to the new unit
      const converted = convertDimensions(previousUnit, unit);

      // Toggle Inputs and update values
      inputGroups.forEach(g => {
        if (g.dataset.inputGroup === unit) {
          g.style.display = 'flex';
          g.classList.remove('hidden');

          // Update input values with converted dimensions
          if (unit === 'inch' || unit === 'cm') {
            const widthInput = g.querySelector('[data-dim="width"]');
            const heightInput = g.querySelector('[data-dim="height"]');
            if (widthInput && converted.w > 0) widthInput.value = converted.w;
            if (heightInput && converted.h > 0) heightInput.value = converted.h;
          } else if (unit === 'fi') {
            const wFtInput = g.querySelector('[data-dim="w_ft"]');
            const wInInput = g.querySelector('[data-dim="w_in"]');
            const hFtInput = g.querySelector('[data-dim="h_ft"]');
            const hInInput = g.querySelector('[data-dim="h_in"]');
            if (wFtInput && (converted.w_ft > 0 || converted.w_in > 0)) wFtInput.value = converted.w_ft;
            if (wInInput && (converted.w_ft > 0 || converted.w_in > 0)) wInInput.value = converted.w_in;
            if (hFtInput && (converted.h_ft > 0 || converted.h_in > 0)) hFtInput.value = converted.h_ft;
            if (hInInput && (converted.h_ft > 0 || converted.h_in > 0)) hInInput.value = converted.h_in;
          }
        } else {
          g.style.display = 'none';
          g.classList.add('hidden');
        }
      });

      // Update currentDims with converted values
      currentDims = { ...currentDims, ...converted };

      formUnit.value = unit;

      updateMaterialPrices(unit);

      calculate();
    }

    // Convert dimensions between units
    function convertDimensions(fromUnit, toUnit) {
      // First, get current dimensions in inches (as base unit)
      let widthInches = 0;
      let heightInches = 0;

      if (fromUnit === 'inch') {
        widthInches = currentDims.w || 0;
        heightInches = currentDims.h || 0;
      } else if (fromUnit === 'cm') {
        widthInches = (currentDims.w || 0) / 2.54;
        heightInches = (currentDims.h || 0) / 2.54;
      } else if (fromUnit === 'fi') {
        widthInches = ((currentDims.w_ft || 0) * 12) + (currentDims.w_in || 0);
        heightInches = ((currentDims.h_ft || 0) * 12) + (currentDims.h_in || 0);
      }

      // If no dimensions, return empty
      if (widthInches === 0 && heightInches === 0) {
        return { w: 0, h: 0, w_ft: 0, w_in: 0, h_ft: 0, h_in: 0 };
      }

      // Convert from inches to target unit
      let result = { w: 0, h: 0, w_ft: 0, w_in: 0, h_ft: 0, h_in: 0 };

      if (toUnit === 'inch') {
        result.w = Math.round(widthInches);
        result.h = Math.round(heightInches);
      } else if (toUnit === 'cm') {
        result.w = Math.round(widthInches * 2.54);
        result.h = Math.round(heightInches * 2.54);
      } else if (toUnit === 'fi') {
        result.w_ft = Math.floor(widthInches / 12);
        result.w_in = Math.round(widthInches % 12);
        result.h_ft = Math.floor(heightInches / 12);
        result.h_in = Math.round(heightInches % 12);
        // Handle 12 inches overflow
        if (result.w_in >= 12) { result.w_ft++; result.w_in = 0; }
        if (result.h_in >= 12) { result.h_ft++; result.h_in = 0; }
      }

      return result;
    }

    function getDimensionsInMeters() {
      let widthM = 0;
      let heightM = 0;
      let widthDisplay = '';
      let heightDisplay = '';
      let sizeCode = '';

      if (currentUnit === 'cm') {
        widthM = currentDims.w / 100;
        heightM = currentDims.h / 100;
        widthDisplay = `${currentDims.w} cm`;
        heightDisplay = `${currentDims.h} cm`;
        sizeCode = `CM-${currentDims.w}x${currentDims.h}`;
      } else if (currentUnit === 'inch') {
        widthM = currentDims.w * 0.0254;
        heightM = currentDims.h * 0.0254;
        widthDisplay = `${currentDims.w} in`;
        heightDisplay = `${currentDims.h} in`;
        sizeCode = `IN-${currentDims.w}x${currentDims.h}`;
      } else if (currentUnit === 'fi') {
        const totalWInch = (currentDims.w_ft * 12) + currentDims.w_in;
        const totalHInch = (currentDims.h_ft * 12) + currentDims.h_in;
        widthM = totalWInch * 0.0254;
        heightM = totalHInch * 0.0254;
        widthDisplay = `${currentDims.w_ft}' ${currentDims.w_in}"`;
        heightDisplay = `${currentDims.h_ft}' ${currentDims.h_in}"`;
        sizeCode = `FI-${currentDims.w_ft}ft${currentDims.w_in}in_H${currentDims.h_ft}ft${currentDims.h_in}in`;
      }

      return { widthM, heightM, widthDisplay, heightDisplay, sizeCode };
    }

    function calculate() {
      if (!selectedMaterial) {
        setInvalid('Select a material');
        return;
      }

      const { widthM, heightM, widthDisplay, heightDisplay, sizeCode } = getDimensionsInMeters();

      if (widthM <= 0 || heightM <= 0) {
        setInvalid('Enter valid dimensions');
        return;
      }

      let areaSqM = widthM * heightM;
      if (areaSqM < 1) areaSqM = 1;

      const totalPriceCents = Math.round(areaSqM * selectedMaterial.price_per_sqm);

      // Calculate area in the current unit
      let areaDisplay = '';
      let areaValue = '';
      if (currentUnit === 'cm') {
        areaDisplay = `${areaSqM.toFixed(2)} m²`;
        areaValue = areaSqM.toFixed(2);
      } else if (currentUnit === 'inch') {
        const areaSqFt = areaSqM * 10.7639;
        areaDisplay = `${areaSqFt.toFixed(2)} sq ft`;
        areaValue = areaSqFt.toFixed(2);
      } else if (currentUnit === 'fi') {
        const areaSqFt = areaSqM * 10.7639;
        areaDisplay = `${areaSqFt.toFixed(2)} sq ft`;
        areaValue = areaSqFt.toFixed(2);
      }

      // Update UI
      sumSize.textContent = `${widthDisplay} x ${heightDisplay}`;
      sumArea.textContent = areaDisplay;

      // Update Price Displays
      applyPriceDisplay(totalPriceCents);

      // Update Form
      formWidth.value = widthDisplay;
      formHeight.value = heightDisplay;
      formArea.value = areaValue;
      if (formSizeCode) formSizeCode.value = sizeCode;

      // Enable Add to Cart & Hide Helper
      if (addButton) addButton.disabled = false;
      if (validationNote) validationNote.style.display = 'none';
    }

    function setInvalid(msg) {
      sumSize.textContent = '—';
      sumArea.textContent = '—';
      resetPriceDisplay();

      // Keep button enabled for Google Merchant compatibility
      // Validation happens on form submit
      if (validationNote) {
        validationNote.style.display = 'block';
      }
    }

    // 4. Sample Button Logic
    const selectSampleMaterialById = (id) => {
      const material = materials.find((item) => item.id === id);
      if (material) selectMaterial(material);
    };

    const addSampleToCart = async () => {
      if (!selectedMaterial || !sampleButton) return;

      // Wall Mural products skip the buy_buttons form, so productForm is
      // often null on these pages. Fall back to the picker's data-variant-id.
      const variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
      const variantId = (variantInput && variantInput.value) || container.getAttribute('data-variant-id') || null;

      if (!variantId) {
        console.error('Variant ID not found');
        return;
      }

      const originalMarkup = sampleButton.innerHTML;
      sampleButton.classList.add('loading');
      sampleButton.textContent = 'Adding...';

      const formData = {
        'items': [{
          'id': variantId,
          'quantity': 1,
          'properties': {
            'Material': selectedMaterial.label,
            'Size': 'Sample (9 × 20 in)',
            '_custom_price': toDisplayCurrency(600), // $6.00 in display currency cents
            '_custom_price_usd': 600, // canonical USD cents (cart re-converts on market change)
            'Calculated price': formatMoney(toDisplayCurrency(600)),
            'Material code': selectedMaterial.id,
            'Size code': 'SAMPLE',
            '_is_sample': 'yes'
          }
        }]
      };

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (response.ok) {
          sampleButton.classList.remove('loading');
          window.location.href = '/cart';
          return;
        }
        throw new Error(await response.text() || 'Could not add sample');
      } catch (err) {
        console.error('Fetch error:', err);
        sampleButton.textContent = 'Could not add sample';
        setTimeout(() => {
          sampleButton.innerHTML = originalMarkup;
        }, 1600);
      }

      sampleButton.classList.remove('loading');
    };

    if (sampleButton) {
      sampleButton.addEventListener('click', () => {
        if (!selectedMaterial) return;
        if (window.DKSampleConfirm) {
          window.DKSampleConfirm.open({
            materials: materials.map((material, index) => ({
              id: material.id,
              label: material.label || material.id,
              description: material.description || '',
              popular: index === 0
            })),
            currentId: selectedMaterial.id,
            priceText: formatMoney(toDisplayCurrency(600)),
            onSelect: selectSampleMaterialById,
            onConfirm: (id) => {
              if (id) selectSampleMaterialById(id);
              addSampleToCart();
            }
          });
        } else {
          addSampleToCart();
        }
      });
    }

    // Unit Radio Listener
    unitRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        if (e.target.checked) {
          switchUnit(e.target.value);
        }
      });
    });

    // Input Listeners
    container.querySelectorAll('input[type="number"]').forEach(input => {
      // Prevent scroll from changing value
      input.addEventListener('wheel', (e) => {
        e.preventDefault();
        input.blur();
      }, { passive: false });

      input.addEventListener('input', (e) => {
        const key = e.target.dataset.dim;
        const val = parseFloat(e.target.value) || 0;

        if (key === 'width') currentDims.w = val;
        if (key === 'height') currentDims.h = val;
        if (key === 'w_ft') currentDims.w_ft = val;
        if (key === 'w_in') currentDims.w_in = val;
        if (key === 'h_ft') currentDims.h_ft = val;
        if (key === 'h_in') currentDims.h_in = val;

        calculate();
      });
    });

    // Set initial unit based on default checked radio
    const initiallyCheckedRadio = container.querySelector('input[name="unit_selector"]:checked');
    if (initiallyCheckedRadio) {
      switchUnit(initiallyCheckedRadio.value);
    } else {
      switchUnit('inch'); // Fallback
    }

    // Auto-select Non-Woven Wallpaper and set 30x30 inches
    const autoSelectDefaults = () => {
      const nonWovenMaterial = materials.find(m => m.id === 'Non-Woven Wallpaper');
      if (nonWovenMaterial) {
        selectMaterial(nonWovenMaterial);

        // Set default dimensions to 30x30 inches
        currentDims.w = 30;
        currentDims.h = 30;

        // Update input fields
        const widthInput = container.querySelector('[data-dim="width"]');
        const heightInput = container.querySelector('[data-dim="height"]');
        if (widthInput) widthInput.value = 30;
        if (heightInput) heightInput.value = 30;

        calculate();
      }
    };

    // Call auto-select after setup
    if (materials.length > 0) {
      autoSelectDefaults();
    } else {
      setInvalid();
    }

    // Build a FormData payload from the hidden inputs inside the picker.
    // Used when the page has no `<form>` (Wall Mural products skip the
    // theme's buy_buttons form), so we POST to cart/add.js directly.
    function buildPickerFormData() {
      const fd = new FormData();
      const variantId = container.getAttribute('data-variant-id') || '';
      if (variantId) fd.append('id', variantId);
      // Quantity (default 1)
      const qty = container.querySelector('[name="quantity"]');
      fd.append('quantity', qty && qty.value ? qty.value : '1');
      // Pull every hidden input inside the picker — they carry properties[*].
      container.querySelectorAll('input[type="hidden"][name]').forEach((inp) => {
        if (inp.name === 'id' || inp.name === 'quantity') return;
        fd.append(inp.name, inp.value || '');
      });
      return fd;
    }

    async function submitAddToCart(formData) {
      const priceValue = formPrice ? formPrice.value : '';
      if (!selectedMaterial || !priceValue || priceValue === '0') {
        container.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (validationNote) {
          validationNote.style.display = 'block';
          validationNote.style.animation = 'shake 0.5s ease';
          setTimeout(() => validationNote.style.animation = '', 500);
        }
        return;
      }

      const addBtn = addToCartButton || container.querySelector('[data-add-to-cart]');
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
      }

      try {
        const config = {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        };
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', config);
        const cartData = await response.json();

        if (response.ok) {
          if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
            window.Shopify.analytics.publish('product_added_to_cart', {
              cartLine: {
                merchandise: {
                  product: {
                    id: container.dataset.productId || '',
                    title: container.dataset.productTitle || document.querySelector('.product__title')?.textContent?.trim() || '',
                    vendor: container.dataset.productVendor || '',
                    type: container.dataset.productType || ''
                  }
                },
                quantity: parseInt(formData.get('quantity')) || 1,
                cost: { totalAmount: { amount: cartData.price / 100, currencyCode: window.Shopify.currency?.active || 'USD' } }
              }
            });
          }
          if (window.klaviyo) {
            window.klaviyo.push(['track', 'Added to Cart', {
              '$value': cartData.price / 100,
              'ProductName': cartData.product_title,
              'ProductID': cartData.product_id,
              'VariantID': cartData.variant_id,
              'Quantity': cartData.quantity,
              'ImageURL': cartData.featured_image?.url || '',
              'ProductURL': window.location.href
            }]);
          }
          const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (cartNotification) {
            const sectionsUrl = window.location.pathname;
            const sections = cartNotification.getSectionsToRender ? cartNotification.getSectionsToRender().map(s => s.id).join(',') : '';
            if (sections) {
              const sectionResponse = await fetch(sectionsUrl + '?sections=' + sections);
              const sectionData = await sectionResponse.json();
              cartData.sections = sectionData;
            }
            if (cartNotification.renderContents) cartNotification.renderContents(cartData);
          } else {
            window.location.href = window.Shopify.routes.root + 'cart';
          }
        } else {
          if (validationNote) {
            validationNote.style.display = 'block';
            validationNote.textContent = cartData.description || 'Error adding to cart';
          }
        }
      } catch (err) {
        console.error('Add to cart error:', err);
      } finally {
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Cart';
        }
      }
    }

    // Form submit - if the buy_buttons form exists, intercept its submit;
    // otherwise bind directly to the Add to Cart button.
    if (productForm) {
      productForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        await submitAddToCart(new FormData(productForm));
      });
    } else if (addToCartButton) {
      addToCartButton.addEventListener('click', async (e) => {
        e.preventDefault();
        await submitAddToCart(buildPickerFormData());
      });
    }

  }

  onReady(() => {
    document.querySelectorAll(SELECTOR).forEach(initMuralPicker);
  });
})();
